module.exports = __webpack_public_path__ + "img/title.bf73b38e.png";